import React from "react";
import { ExternalDirectiveResearch } from "./ExternalDirectiveResearch";

export const AtexResearch = () => (
  <ExternalDirectiveResearch
    eurLexUrl="https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX:32014L0034"
    i18nPrefix="steps.questionaire.atex.research"
  />
);
